import type { ComponentProps } from "react"
import { SelectItem as SelectItemBase } from "@/v2-ui/select/base/SelectBase"
import cn from "@/v2-ui/utils/utils.cn"

export type SelectItemProps = ComponentProps<typeof SelectItemBase>

function SelectItem(props: SelectItemProps) {
  const { className, description, ...selectItemBaseProps } = props
  return (
    <SelectItemBase
      className={cn(
        "ui-select-item",
        // Two lines stack; the single-line item stays centred as before.
        description != null && "ui-select-item--described",
        className,
      )}
      description={description}
      {...selectItemBaseProps}
    />
  )
}

export default SelectItem
